/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state"] }] */
import { round } from 'lodash';

export default {
    namespaced: true,
    state: () => ({
        participants: 1,
        month: new Date(),
        availableDates: [],
        date: null,
        activeRound: 0,
        section: 'date-time',
        confirmed: false,
        booker: {
            uuid: null,
            firstName: null,
            lastName: null,
            email: null,
            phoneCountry: null,
            phoneNumber: null,
            flightId: null,
            memberIndex: null,
            register: false,
            newsletterOptIn: false,
            termsAndConditionsAccepted: false,
            password: null,
            password_confirm: null,
            namesConfirmed: false,
            confirmed: false,
        },
    }),

    getters: {
        /**
         * Returns the country code from the country model
         * currently set as the phoneCountry.
         *
         * @returns {String}
        */
        getPhoneCountryCode() {
            if (!this.booker.phoneCountry) {
                return '';
            }

            return this.phoneCountry.countryCode;
        },
    },

    mutations: {
        setBooker(state, booker) {
            state.booker = booker;
        },

        setConfirmed(state, confirmed) {
            state.confirmed = confirmed;
        },

        setSection(state, section) {
            state.section = section;
        },

        updateRegister(state, value) {
            state.booker.register = value;
        },

        updateNewsletterOptIn(state, value) {
            state.booker.newsletterOptIn = value;
        },

        addParticipant(state) {
            if (state.participants < 8) {
                state.participants += 1;
            }
        },

        removeParticipant(state) {
            if (state.participants > 0) {
                state.participants -= 1;
            }
        },

        setActiveRound(state, roundIndex) {
            state.activeRound = roundIndex;
        },

        setMonth(state, month) {
            state.month = month;
        },

        setDate(state, date) {
            state.date = date;
        },

        updateFlightForIndex(state, flight, index) {
            state.flights[index] = flight;
        },
    },
};
